import { $win } from '../utils/globals';

const $sectionHead = $('.section-heading .section__head');
const $sectionBtn = $sectionHead.find('.btn');

const $sectionInsta = $('.ooo-instagram .ooo-instagram-container');

$win.on('load resize orientationchange', function () {
  const $sectionInstaBtn = $sectionInsta.find('.btn');

  if ($win.width() < 768 && $sectionBtn.length && $sectionInsta.length) {
    $sectionInsta.append($sectionBtn);
  } else if ($win.width() > 767 && $sectionInstaBtn.length) {
    $sectionHead.append($sectionInstaBtn);
  }
});
